{
    "NavigationAll": "[Alle]",
    "NavigationReporting": "Rapportage",
    "NavigationAdministration": "Administratie",
    "NavigationProvisioning": "Provisioning",
    "NavigationDevices": "Apparaten",
    "NavigationEndpoints": "Eindpunten",
    "NavigationTrunking": "Trunking",
    "NavigationHospitality": "Gastvrijheid",
    "NavigationTrunkgateways": "Trunk-gateways",
    "NavigationVoicemailservices": "Voicemaildiensten",
    "NavigationConferencedevices": "Conferentie-apparaten",
    "NavigationAgents": "agenten",
    "NavigationDirectory": "Directory",
    "NavigationCodes": "Codes",
    "NavigationPartitions": "partities",
    "NavigationTelephonyservers": "Telefonieservers",
    "NavigationCmenvironments": "Centrale beheeromgevingen",
    "NavigationApplicationusers": "Toepassingsgebruikers",
    "NavigationOmnichannel": "Omnichannel",
    "NavigationRecording": "Opnemen",
    "NavigationMessages": "Berichten",
    "NavigationDatabase": "Database",
    "NavigationStatustools": "Status en hulpmiddelen",
    "NavigationLicenses": "Licenties",
    "NavigationLogging": "Loggen",
    "NavigationLogmanagement": "Logboekbeheer",
    "NavigationAudittrail": "Auditspoor",
    "NavigationTelephonemodulestatus": "Status telefoonmodule",
    "NavigationOmnichannelmodulestatus": "Omnichannel-status",
    "NavigationCallcontrol": "Oproepbeheer",
    "NavigationServerstatus": "Server Status",
    "NavigationNewAnalytics": "Enterprise-bedrijf toevoegen",
    "NAME": "LanguageMainNavigation",
    "InsightsHub": "Inzichten",
    "Presence": "Aanwezigheid",
    "NavigationUserManagement": "Gebruikersbeheer",
    "NavigationManageUsersDevice": "Gebruikers beheren",
    "NavigationEasyProvisioning": "Eenvoudige provisioning",
    "NavigationManageQueues": "Wachtrijen beheren"
}